import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Page } from '@ohpen/enso-ui';

import { FeatureFlagsList } from '@config/components';

export const FeatureFlagsPage = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <Page>
      <Page.Title>{t('config.sections.featureFlags')}</Page.Title>
      <Page.Content fill>
        <FeatureFlagsList />
      </Page.Content>
    </Page>
  );
};
